// export const removeParagraph = (str = '') => str.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '')

export const removeParagraph = (str = '') => {
  const pOpen = (str.match(/<p[^>]*>/g) || []).length
  const pClose = (str.match(/<\/p>/g) || []).length

  if (pOpen > 1 && pOpen === pClose) {
    const regex = new RegExp('<p[^>]*>([\\s\\S]*?)<\\/p>', 'g')
    return str.replace(
      regex,
      (_, content) => `<span class='p-line'>${content}</span>`
    )
  }

  return str.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '')
}

export const nl2br = (str: string) => {
  return str.replace(/(\r\n|\n\r|\r|\n)/g, '<br />')
}
